import * as types from '@/store/mutation-types'
import {urls, api} from '@/api'

const getInitialState = () => ({

  // Common
  hasChanges: false,

  // Product
  publication_id: 0,
  quantity: 1,
  price_buy_unit: 0,
  total_to_pay: 0,

  // Delivery
  delivery:{
    // Recipient
    recipient:{
      name:"",
      phone:"",
    },
    // Address
    street: '',
    number: '',
    level: '',
    department: '',
    zip_code: '',
    location: '',
    // city: '',
    province: '',
    string: '',
    description: ''
  },

  // Order data
  order:{
    id: 0,
    preference_id: "",
    publication_id: 0,

    // price
    currency_code: "",
    total_price_amount: 0,
    discount: 0,
    final_price_amount: 0,

    // Gateway
    payment_gateway: "",
    init_point: "",
    sandbox_init_point: "",
  },

  // Purchase data
  purchase:{
    id: 0,
    order_status: '',
    title: '',
    merchant_order_id: 0,
    payment_status: '',

    // payment
    total_amount: 0,
    payment_date: '',
    installments: 0
  },

  // Seller info
  seller: {
    fantasy_name: '',
    phone: '',
    address: '',
    email: '',
  },

})


const state = getInitialState()

const actions = {

  setQuantity: ({commit}, quantity) => {
    commit(types.BUY_SET_QUANTITY, quantity)
    let params = {
      payment_gateway: "MERCADOPAGO_MKT",
      buy:[
        {
          publication_id: state.publication_id,
          quantity: state.quantity
        }
      ]
    };
    return new Promise((resolve) => {
      api.post(urls.marketplacePriceCalculation, params )
        .then(({data}) => {
          commit(types.BUY_SET_PRICE_BUY_UNIT, data.data.detail[0].price)
          commit(types.BUY_SET_TOTAL_TO_PAY, data.data.final.total)
          resolve(data);
        })
    })
  },

  // setPriceBuyUnit: ({commit}, priceBuyUnit) => { commit(types.BUY_SET_QUANTITY, priceBuyUnit) },
  // setTotalToPay: ({commit}, totalToPay) => { commit(types.BUY_SET_QUANTITY, totalToPay) },
  setPublicationId: ({commit}, publicationId) => { commit(types.BUY_SET_PUBLICATION_ID, publicationId) },

  // Delivery
  setDeliveryRecipientName: ({commit}, recipient_name) => { commit(types.BUY_DELIVERY_SET_RECIPIENT_NAME, recipient_name) },
  setDeliveryRecipientPhone: ({commit}, recipient_phone) => { commit(types.BUY_DELIVERY_SET_RECIPIENT_PHONE, recipient_phone) },
  setDeliveryStreet: ({commit}, street) => { commit(types.BUY_DELIVERY_SET_STREET, street) },
  setDeliveryNumber: ({commit}, number) => { commit(types.BUY_DELIVERY_SET_NUMBER, number) },
  setDeliveryLevel: ({commit}, level) => { commit(types.BUY_DELIVERY_SET_LEVEL, level) },
  setDeliveryDepartment: ({commit}, department) => { commit(types.BUY_DELIVERY_SET_DEPARTMENT, department) },
  setDeliveryPostalCode: ({commit}, postalCode) => { commit(types.BUY_DELIVERY_SET_ZIP_CODE, postalCode) },
  setDeliveryLocation: ({commit}, location) => { commit(types.BUY_DELIVERY_SET_LOCATION, location) },
  setDeliveryProvince: ({commit}, province) => { commit(types.BUY_DELIVERY_SET_PROVINCE, province) },
  setDeliveryString: ({commit}, string) => { commit(types.BUY_DELIVERY_SET_STRING, string) },
  // setDeliveryCity: ({commit}, city) => { commit(types.BUY_DELIVERY_SET_CITY, city) },
  setDeliveryDescription: ({commit}, description) => { commit(types.BUY_DELIVERY_SET_DESCRIPTION, description) },

  // Price
  setOrderCurrencyCode: ({commit}, currencyCode) => { commit(types.BUY_ORDER_SET_CURRENCY_CODE, currencyCode) },
  setOrderDiscount: ({commit}, discount) => { commit(types.BUY_ORDER_SET_DISCOUNT, discount) },
  setOrderFinalPriceAmount: ({commit}, finalPriceAmount) => { commit(types.BUY_ORDER_SET_FINAL_PRICE_AMOUNT, finalPriceAmount) },

  // Order
  setOrderId: ({commit}, id) => { commit(types.BUY_ORDER_SET_ID, id) },
  setOrderInitPoint: ({commit}, initPoint) => { commit(types.BUY_ORDER_SET_INIT_POINT, initPoint) },
  setOrderPaymentGateway: ({commit}, paymentGateway) => { commit(types.BUY_ORDER_SET_PAYMENT_GATEWAY, paymentGateway) },
  setOrderPreferenceId: ({commit}, preferenceId) => { commit(types.BUY_ORDER_SET_PREFERENCE_ID, preferenceId) },
  setOrderSandboxInitPoint: ({commit}, sandboxInitPoint) => { commit(types.BUY_ORDER_SET_SANDBOX_INIT_POINT, sandboxInitPoint) },
  setOrderTotalPriceAmount: ({commit}, totalPriceAmount) => { commit(types.BUY_ORDER_SET_TOTAL_PRICE_AMOUNT, totalPriceAmount) },

  // create the shipping entry for the order
  createShipping: ({ commit, state, rootState, getters, dispatch }) => {
    return new Promise((resolve, reject) => {
      api.post(`${urls.marketplaceSaveShipment}/${state.order.id}`, state.delivery).then(({ data: response }) => {
        resolve(response);
      }).catch(response => {
        reject(response)
      })
    });
  },

  // once the quantty is defined by te user, create the order
  createOrder: ({ commit, state, rootState, getters, dispatch }) => {
    return new Promise((resolve, reject) => {

      // Create the post payload
      const params = {
        "payment_gateway": 'MERCADOPAGO_MKT',
        "buy": [{
          "publication_id": state.publication_id,
          "quantity": state.quantity
        }]
      }

      // Once we get the order, save it to the store
      api.post(`${urls.marketplaceOrders}`, params).then(({ data: response }) => {
        const order = response.data
        commit('BUY_ORDER_SET_ID', order.id)
        commit('BUY_ORDER_SET_PAYMENT_GATEWAY', order.payment_gateway)
        commit('BUY_ORDER_SET_CURRENCY_CODE', order.currency_code)
        commit('BUY_ORDER_SET_TOTAL_PRICE_AMOUNT', order.total_price_amount)
        commit('BUY_ORDER_SET_DISCOUNT', order.discount)
        commit('BUY_ORDER_SET_FINAL_PRICE_AMOUNT', order.final_price_amount)
        commit('BUY_ORDER_SET_PREFERENCE_ID', order.preference_id)
        commit('BUY_ORDER_SET_SANDBOX_INIT_POINT', order.sandbox_init_point)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getOrder: ({ commit, state, rootState, getters, dispatch }, orderId) => {
    api.get(`${urls.marketplaceOrders}/${orderId}`).then(({data: response}) => {
      dispatch("setOrder", response)
    })
  },

  getInitPoint: ({ commit, state, rootState, getters, dispatch }, orderId) => {
    return new Promise((resolve, reject) => {
      api.get(`${urls.marketplaceOrders}/${orderId}/init-point`)
        .then(({data: response}) => {
          dispatch("setOrderInitPoint", response.data.init_point);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    })
  },

  setOrder: ({ commit, state, rootState, getters, dispatch }, order) => {
    commit('BUY_ORDER_SET_ID', order.data.id)
    commit('BUY_ORDER_SET_CURRENCY_CODE', order.data.currency_code)
    commit('BUY_ORDER_SET_DISCOUNT', order.data.discount)
    commit('BUY_ORDER_SET_FINAL_PRICE_AMOUNT', order.data.final_price_amount)
    commit('BUY_ORDER_SET_PAYMENT_GATEWAY', order.data.payment_gateway)
    commit('BUY_ORDER_SET_PREFERENCE_ID', order.data.preference_id)
    commit('BUY_ORDER_SET_SANDBOX_INIT_POINT', order.data.sandbox_init_point)
    commit('BUY_ORDER_SET_TOTAL_PRICE_AMOUNT', order.data.total_price_amount)
    commit('BUY_ORDER_SET_PUBLICATION_ID', order.data.products[0].publication_id)
    commit('BUY_SET_QUANTITY', order.data.products[0].quantity)

    if(order.data.shipping != '') {
      // commit('BUY_DELIVERY_SET_CITY', order.data.shipping.city)
      // commit('BUY_DELIVERY_SET_DESCRIPTION', order.data.shipping.description)
      // commit('BUY_DELIVERY_SET_STRING', order.data.shipping.string)

      // commit('BUY_DELIVERY_SET_STREET', order.data.shipping.string.split(",")[0])
      // commit('BUY_DELIVERY_SET_NUMBER', order.data.shipping.string.split(",")[1])
      // commit('BUY_DELIVERY_SET_LEVEL', order.data.shipping.string.split(",")[2])
      // commit('BUY_DELIVERY_SET_DEPARTMENT', order.data.shipping.string.split(",")[3])
      // commit('BUY_DELIVERY_SET_ZIP_CODE', order.data.shipping.city.split(",")[0])
      // commit('BUY_DELIVERY_SET_LOCATION', order.data.shipping.city.split(",")[0])
      // commit('BUY_DELIVERY_SET_PROVINCE', order.data.shipping.city.split(",")[1])
      // commit('BUY_DELIVERY_SET_RECIPIENT_NAME', order.data.shipping.recipient_name)
      // commit('BUY_DELIVERY_SET_RECIPIENT_PHONE', order.data.shipping.recipient_phone)
    }

  },

  getPurchase: ({ commit, state, rootState, getters, dispatch }, orderId) => {
    return new Promise((resolve, reject) => {
      api.get(`${urls.marketplacePurchase}/${orderId}`).then(({data: response}) => {
        dispatch("setPurchase", response)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },

  setPurchase: ({ commit, state, rootState, getters, dispatch }, purchase) => {
    commit('BUY_PURCHASE_SET_ID', purchase.data.external_reference)
    commit('BUY_PURCHASE_SET_MERCHANT_ORDER_ID', purchase.data.id)
    commit('BUY_PURCHASE_SET_TOTAL_AMOUNT', purchase.data.total_amount)
    commit('BUY_PURCHASE_SET_TITLE', purchase.data.items[0].title)
    commit('BUY_PURCHASE_SET_PAYMENT_STATUS', purchase.data.payments[0].status)
    // commit('BUY_PURCHASE_SET_ORDER_STATUS', purchase.data.order_status.toUpperCase())
    commit('BUY_PURCHASE_SET_INSTALLMENTS', purchase.data.payments[0].installments)
    commit('BUY_PURCHASE_SET_PAYMENT_DATE', purchase.data.payments[0].date_created)

    if(purchase.data.shipping.string) {
      // commit('BUY_DELIVERY_SET_CITY', purchase.data.shipping.city)
      commit('BUY_DELIVERY_SET_DESCRIPTION', purchase.data.shipping.description)
      commit('BUY_DELIVERY_SET_STRING', purchase.data.shipping.string)

      // commit('BUY_DELIVERY_SET_STREET', purchase.data.shipping.string.split(",")[0])
      // commit('BUY_DELIVERY_SET_NUMBER', purchase.data.shipping.string.split(",")[1])
      // commit('BUY_DELIVERY_SET_LEVEL', purchase.data.shipping.string.split(",")[2])
      // commit('BUY_DELIVERY_SET_DEPARTMENT', purchase.data.shipping.string.split(",")[3])
      // commit('BUY_DELIVERY_SET_LOCATION', purchase.data.shipping.city.split(",")[0])
      // commit('BUY_DELIVERY_SET_PROVINCE', purchase.data.shipping.city.split(",")[1])
      commit('BUY_DELIVERY_SET_RECIPIENT_NAME', purchase.data.shipping.recipient_name)
      commit('BUY_DELIVERY_SET_RECIPIENT_PHONE', purchase.data.shipping.recipient_phone)
    }

    commit('BUY_SELLER_SET_FANTASY_NAME', purchase.data.seller.name)
    commit('BUY_SELLER_SET_PHONE', purchase.data.seller.phone.number || '')
    commit('BUY_SELLER_SET_ADDRESS', purchase.data.seller.location.string)
    commit('BUY_SELLER_SET_EMAIL', purchase.data.seller.email)
  },

  cleanPurchase: ({commit}) => new Promise((resolve, reject) => {
    commit(types.PURCHASE_RESET_STATE)
    resolve()
  }),
}

const mutations = {
  [types.BUY_SET_QUANTITY] (state, quantity) {
    state.quantity = quantity
  },
  [types.BUY_SET_PRICE_BUY_UNIT] (state, priceBuyUnit) {
    state.price_buy_unit = priceBuyUnit
  },
  [types.BUY_SET_TOTAL_TO_PAY] (state, totalToPay) {
    state.total_to_pay = totalToPay
  },
  [types.BUY_SET_PUBLICATION_ID] (state, publicationId) {
    state.publication_id = publicationId
  },
  [types.BUY_DELIVERY_SET_STREET] (state, street) {
    state.delivery.street = street
  },
  [types.BUY_DELIVERY_SET_NUMBER] (state, number) {
    state.delivery.number = number
  },
  [types.BUY_DELIVERY_SET_LEVEL] (state, level) {
    state.delivery.level = level
  },
  [types.BUY_DELIVERY_SET_DEPARTMENT] (state, department) {
    state.delivery.department = department
  },
  [types.BUY_DELIVERY_SET_ZIP_CODE] (state, zip_code) {
    state.delivery.zip_code = zip_code
  },
  [types.BUY_DELIVERY_SET_LOCATION] (state, location) {
    state.delivery.location = location
  },
  [types.BUY_DELIVERY_SET_PROVINCE] (state, province) {
    state.delivery.province = province
  },
  [types.BUY_DELIVERY_SET_STRING] (state, string) {
    state.delivery.string = string
  },
  // [types.BUY_DELIVERY_SET_CITY] (state, city) {
    //   state.delivery.city = city
  // },
  [types.BUY_DELIVERY_SET_DESCRIPTION] (state, description) {
    state.delivery.description = description
  },
  [types.BUY_DELIVERY_SET_RECIPIENT_NAME] (state, recipient_name) {
    state.delivery.recipient.name = recipient_name
  },
  [types.BUY_DELIVERY_SET_RECIPIENT_PHONE] (state, recipient_phone) {
    state.delivery.recipient.phone = recipient_phone
  },
  [types.BUY_ORDER_SET_CURRENCY_CODE] (state,currency_code) {
    state.order.currency_code = currency_code
  },
  [types.BUY_ORDER_SET_DISCOUNT] (state, discount) {
    state.order.discount = discount
  },
  [types.BUY_ORDER_SET_FINAL_PRICE_AMOUNT] (state, final_price_amount) {
    state.order.final_price_amount = final_price_amount
  },
  [types.BUY_ORDER_SET_ID] (state, id) {
    state.order.id = id
  },
  [types.BUY_ORDER_SET_INIT_POINT] (state, init_point) {
    state.order.init_point = init_point
  },
  [types.BUY_ORDER_SET_PAYMENT_GATEWAY] (state, payment_gateway) {
    state.order.payment_gateway = payment_gateway
  },
  [types.BUY_ORDER_SET_PREFERENCE_ID] (state, preference_id) {
    state.order.preference_id = preference_id
  },
  [types.BUY_ORDER_SET_SANDBOX_INIT_POINT] (state, sandbox_init_point) {
    state.order.sandbox_init_point = sandbox_init_point
  },
  [types.BUY_ORDER_SET_TOTAL_PRICE_AMOUNT] (state, total_price_amount) {
    state.order.total_price_amount = total_price_amount
  },
  [types.BUY_ORDER_SET_PUBLICATION_ID] (state, publication_id) {
    state.order.publication_id = publication_id
  },
  [types.BUY_PURCHASE_SET_ID] (state, id) {
    state.purchase.id = id
  },
  [types.BUY_PURCHASE_SET_MERCHANT_ORDER_ID] (state, merchantOrderId) {
    state.purchase.merchant_order_id = merchantOrderId
  },
  [types.BUY_PURCHASE_SET_TOTAL_AMOUNT] (state, totalAmount) {
    state.purchase.total_amount = totalAmount
  },
  [types.BUY_PURCHASE_SET_TITLE] (state, title) {
    state.purchase.title = title
  },

  [types.BUY_PURCHASE_SET_ORDER_STATUS] (state, orderStatus) {
    state.purchase.order_status = orderStatus
  },

  [types.BUY_PURCHASE_SET_PAYMENT_STATUS] (state, status) {
    state.purchase.payment_status = status
  },

  [types.BUY_PURCHASE_SET_INSTALLMENTS] (state, installments) {
    state.purchase.installments = installments
  },

  [types.BUY_PURCHASE_SET_PAYMENT_DATE] (state, paymentDate) {
    state.purchase.payment_date = paymentDate
  },

  [types.BUY_SELLER_SET_FANTASY_NAME] (state, fantasyName) {
    state.seller.fantasy_name = fantasyName
  },
  [types.BUY_SELLER_SET_PHONE] (state, phone) {
    state.seller.phone = phone
  },
  [types.BUY_SELLER_SET_ADDRESS] (state, address) {
    state.seller.address = address
  },
  [types.BUY_SELLER_SET_EMAIL] (state, email) {
    state.seller.email = email
  },

  [types.PURCHASE_RESET_STATE] (state) {
    Object.assign(state, getInitialState())
  },

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/buy.js